import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { AutocompleteInput, DateInput, List, Datagrid, DateField, TextField, ReferenceField, EditButton, Edit, SimpleForm, ReferenceInput, TextInput, SelectInput, DisabledInput, LongTextInput, Create, Filter } from 'react-admin';
import gql from 'graphql-tag';
import { ApolloClient } from 'apollo-boost';
import { GttpLink, HttpLink } from 'apollo-link-http';
import { ApolloProvider } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';

const query = gql`
query{
	product{
		id
		name
	}
}
`;
const cache = new InMemoryCache();
const httpLink = new HttpLink({
	uri: 'http://aws-cloud9.asuscomm.com:8080/v1/graphql',
	headers: {
		'content-type': 'application/json'
	}
})
const client = new ApolloClient({
	link: httpLink,
	cache: cache
})


export const AdminEdit = props => (
	<Edit {...props}>
		<SimpleForm>
		</SimpleForm>
	</Edit>
)
const getProducts = async () => {
	var result = await client.query({
		query: query
	});
	return result.data.product;
}

export const GroupPurchaseCreate = props => (
	<Create {...props}>
		<SimpleForm>
			<DateInput source="due_date" label="종료기한" />
			<ReferenceInput label="상품명" source="product_id" reference="product">
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
		</SimpleForm>
	</Create>
)
export const GroupPurchaseList = props => {
	return (<List /*filters={<PostFilter />}*/ {...props} title="관리자">
		<Datagrid>
			<TextField source="id" label="일련번호" />
			<DateField source="due_date" label="종료기한" />
			<DateField source="end_date" label="종료일시" />
			<ReferenceField source="product_id" label="제품" reference="product">
				<TextField source="name" />
			</ReferenceField>
			<EditButton />
		</Datagrid>
	</List>
	)
}